import { useContext } from 'react';
import EventContext from "../event-context";
export default function useEvent() {
  var eventContext = useContext(EventContext);
  return eventContext;
}